import { useNavigate } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import { DELETE_POST } from '../mutations/postMutations';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast';
import { useState } from 'react';

export default function DeletePostButton({ postId }) {
  const navigate = useNavigate()

  const [isDeleting, setIsDeleting] = useState(false)

  const [deletePost] = useMutation(DELETE_POST, {
    variables: { id: postId },
    onCompleted: () => {
      toast.success('Post got deleted successfully')
      navigate('/')
      setIsDeleting(false)
    },
    onError: (error) => {
      toast.error(error.message)
      setIsDeleting(false)
    }
  })

  const handleDelete = () => {
    setIsDeleting(true)

    deletePost({ variables: { id: postId } })
  }

  return (
    <div className='d-flex ms-auto mb-2'>
      <button className='btn btn-danger ' onClick={handleDelete}>
        <div className='d-flex align-items-center rfs-5'>
          {isDeleting ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : <FaTrash className='me-2 icon' />}
          {isDeleting ? 'Deleting...' : 'Delete Post'}
        </div>
      </button>
    </div>
  )
}
